import { render, staticRenderFns } from "./SettingImage.vue?vue&type=template&id=1c3c3f22&scoped=true&"
import script from "./SettingImage.vue?vue&type=script&lang=js&"
export * from "./SettingImage.vue?vue&type=script&lang=js&"
import style0 from "./SettingImage.vue?vue&type=style&index=0&id=1c3c3f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c3f22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
